export default __webpack_public_path__ + "e4a5d47439be14861ea548c7d10d2e59.png";